import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './components/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import './styles/app.scss';

import * as firebase from 'firebase';

var config = {
    apiKey: 'AIzaSyDS6sublactQ_PjVt4CjzpJDRbdJmfcjIk',
    authDomain: 'cokear-e6b11.firebaseapp.com',
    databaseURL: 'https://cokear-e6b11.firebaseio.com',
    projectId: 'cokear-e6b11',
    storageBucket: 'cokear-e6b11.appspot.com',
    messagingSenderId: '576391993696'
};

firebase.initializeApp(config);

ReactDOM.render(<App />, document.getElementById('app'));


// WEBPACK FOOTER //
// ./src/index.js